import { create } from 'zustand';

/**
 * User Store - Replaces reactn global user state
 * Manages authentication and user profile data
 */
const useUserStore = create((set, get) => ({
  // User object containing profile, tokens, etc.
  // Initialize as empty object for backward compatibility with reactn
  user: {},

  // Auth-related fields
  _id: null,
  email: null,
  username: null,
  first_name: null,
  last_name: null,
  full_name: null,
  avatar: null,
  tokens: null,
  org: null,
  orgs: null,
  role: null,
  permissions: null,
  settings: null,

  // Actions
  setUser: userData => {
    if (!userData) {
      set({
        user: {},
        _id: null,
        email: null,
        username: null,
        first_name: null,
        last_name: null,
        full_name: null,
        avatar: null,
        tokens: null,
        org: null,
        orgs: null,
        role: null,
        permissions: null,
        settings: null,
      });
      return;
    }

    set({
      user: userData,
      _id: userData._id,
      email: userData.email,
      username: userData.username,
      first_name: userData.first_name,
      last_name: userData.last_name,
      full_name: userData.full_name,
      avatar: userData.avatar,
      tokens: userData.tokens,
      org: userData.org,
      orgs: userData.orgs,
      role: userData.role,
      permissions: userData.permissions,
      settings: userData.settings,
    });
  },

  updateUser: updates => {
    const currentUser = get().user;
    const updatedUser = { ...currentUser, ...updates };
    set({
      user: updatedUser,
      ...updates,
    });
  },

  resetUser: () => {
    set({
      user: {},
      _id: null,
      email: null,
      username: null,
      first_name: null,
      last_name: null,
      full_name: null,
      avatar: null,
      tokens: null,
      org: null,
      orgs: null,
      role: null,
      permissions: null,
      settings: null,
    });
  },
}));

// Helper to get user state outside React components
export const getUserState = () => useUserStore.getState();

// Helper to set user state outside React components
export const setGlobalUser = userData => {
  useUserStore.getState().setUser(userData);
};

// Helper to reset user state outside React components
export const resetGlobalUser = () => {
  useUserStore.getState().resetUser();
};

export default useUserStore;
